import { toast } from 'react-toastify';
import { winnreAuth } from '../../../../utils/axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useAxios from '../../../../Hooks/use-axios';

const useData = (userHash, dealId, otp, setOtp, cartAmount) => {
    const [deals, setDeals] = useState('');
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [timeLeftToResend, setTimeLeftToResend] = useState(0);
    // const [userAccountSummary, setUserAccountSummary] = useState(null);

    const [otpLoading, setOtpLoading] = useState(false);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    useAxios();
    const { isLoading: loadingDeal, sendRequest: fetchDeals } = useAxios();

    // useEffect(() => {
    //     if (isAuthenticated) {
    //         getUserAccountSummary();
    //     }
    // }, [isAuthenticated]);

    //Get account summary data
    // const getUserAccountSummary = () => {
    //     winnreAuth({
    //         method: 'get',
    //         url: '/winnre/user/booking/account-summary'
    //     })
    //         .then((res) => {
    //             console.log('accoi', res);
    //             setUserAccountSummary(res);
    //         })
    //         .catch((e) => {
    //             setUserAccountSummary(null);
    //         });
    // };

    const getOtp = () => {
        setOtpLoading(true);
        setOtp('');
        window?.webengage?.track('AddressFilled');
        window?.webengage?.track('RewardsOTPRequsted');

        setShowOtpModal(true);

        winnreAuth({
            method: 'GET',
            url: `/winnre/user/deals/generate-otp?userHash=${userHash}`
        })
            .then((res) => {
                setOtpLoading(false);
                console.log('Get OTP:', res);
                if (res?.status === 'SUCCESS') {
                    setTimeLeftToResend(59);
                } else {
                    toast.error(res?.message);
                }
            })
            .catch((err) => {
                console.log(err);
                toast.error('Something went wrong. Please try again');
            });
    };

    const getOffers = () => {
        const oldCartData = localStorage.getItem('cartData');

        let cartData = {
            cartValues: [],
            totalMrp: 0,
            totalProduct: 0,
            totalPoints: 0
        };
        if (oldCartData) {
            cartData = JSON.parse(oldCartData);
        }

        fetchDeals(
            {
                isEncryptedResponse: isAuthenticated ? true : false,
                url: `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=10&rewardsPage=true&cartValue=${cartData?.totalPoints}`,
                method: 'get',
                isFormData: true
            },
            (res) => {
                console.log('ordersPage Deals', res?.content);
                setDeals(res?.content);
            }
        );
    };
    return {
        deals,
        loadingDeal,
        showOtpModal,
        setShowOtpModal,
        getOtp,
        timeLeftToResend,
        // userAccountSummary,
        setTimeLeftToResend,
        getOffers,
        otpLoading
    };
};
export default useData;
